import React from 'react';
import { Header } from '../components/landing/Header';
import { Hero } from '../components/landing/Hero';
import { Stats } from '../components/landing/Stats';
import { Features } from '../components/landing/Features';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Testimonials } from '../components/landing/Testimonials';
import { Pricing } from '../components/landing/Pricing';
import { Integrations } from '../components/landing/Integrations';
import { CallToAction } from '../components/landing/CallToAction';
import { Footer } from '../components/landing/Footer';

export function LandingPage() {
  return (
    <div className="bg-white">
      <Header />
      <main className="relative">
        {/* Decorative background elements */}
        <div className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80">
          <div className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-purple-600 to-indigo-600 opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" />
        </div>

        {/* Hero Section */}
        <section aria-labelledby="hero-section" className="relative isolate px-6 pt-14 lg:px-8">
          <Hero />
        </section>

        {/* Stats Section */}
        <section aria-labelledby="stats-section" className="relative">
          <Stats />
        </section>

        {/* Features Section */}
        <section aria-labelledby="features-section" className="relative">
          <Features />
        </section>

        {/* How It Works Section */}
        <section aria-labelledby="how-it-works-section" className="relative">
          <HowItWorks />
        </section>

        {/* Testimonials Section */}
        <section aria-labelledby="testimonials-section" className="relative">
          <Testimonials />
        </section>

        {/* Pricing Section */}
        <section aria-labelledby="pricing-section" className="relative">
          <Pricing />
        </section>

        {/* Integrations Section */}
        <section aria-labelledby="integrations-section" className="relative">
          <Integrations />
        </section>

        {/* Call to Action Section */}
        <section aria-labelledby="call-to-action-section" className="relative">
          <CallToAction />
        </section>

        {/* Decorative bottom background */}
        <div className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
          <div className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-purple-600 to-indigo-600 opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]" />
        </div>
      </main>

      <Footer />
    </div>
  );
}